import CreatePlanForEmployee from 'forms/CreatePlanForEmployee'

// project import
import DashboardLayout from 'layout/Dashboard'
import Pages from 'layout/Pages'

import ClosePeriods from 'pages/Admin/Accruals/ClosePeriods'
import ClosePeriod from 'pages/Admin/Accruals/ClosePeriod'
import PeriodPlansManagement from 'pages/Admin/PeriodPlansManagement'
import Ledger from 'pages/Admin/Accruals/Ledger'
import ManageAccruals from 'pages/Admin/Accruals/ManageAccruals'
import EditApproval from 'pages/Admin/Approvals/EditApproval'
import ManageApprovals from 'pages/Admin/Approvals/ManageApprovals'
import CreateMetrics from 'pages/Admin/Components/CreateMetrics'

import CreateTargets from 'pages/Admin/Components/CreateTargets'
import EditMetric from 'pages/Admin/Components/EditMetric'
import EditTarget from 'pages/Admin/Components/EditTarget'
import CreateComponent from 'pages/Admin/Components/ManageComponents/CreateComponent'
import EditComponent from 'pages/Admin/Components/ManageComponents/EditComponent'
import ManageComponents from 'pages/Admin/Components/ManageComponents/ManageComponents'
import ManageMetrics from 'pages/Admin/Components/ManageComponents/ManageMetrics'
import ManageTargets from 'pages/Admin/Components/ManageComponents/ManageTargets'
import ManageLedgerAccounts from 'pages/Admin/LedgerAccounts/ManageLedgerAccounts'
import {
  CreateRewards,
  EditRewards,
  ManageRewards,
  RewardPackages,
  EmployeeRewards,
  EmployeeRewardsDashboard,
  EditEmployeeRewards,
  CreatePackage,
  EditPackage,
  EditCategories,
} from 'pages/Admin/Rewards'
import ManageOrganizationStructure from 'pages/Admin/Organizations/ManageOrganizationStructure'
import CopyTemplateSwitch from 'pages/Admin/Templates/CopyTemplateSwitch'
import CreateTemplateSwitch from 'pages/Admin/Templates/CreateTemplateSwitch'
import EditTemplateSwitch from 'pages/Admin/Templates/EditTemplateSwitch'
import ManageTemplates from 'pages/Admin/Templates/ManageTemplates'
import SelectTemplate from 'pages/Admin/Templates/SelectTemplate'
import ViewTemplate from 'pages/Admin/Templates/ViewTemplate'
import CompensationPlan from 'pages/CompPlan'
import CompPlans from 'pages/CompPlans'
import Dashboard from 'pages/Dashboard'
import EmployeePlanView from 'pages/IncentiveDashboard/EmployeePlanView'

import JumpStartWizard from 'pages/JumpStartWizard'
import Organization from 'pages/Organization'
import PendingSetup from 'pages/Organization/PendingSetup.tsx'
import OrganizationSettings from 'pages/OrganizationSettings'
import OrganizationContactSettings from 'pages/ContactSettings'
import SecuritySettings from 'pages/SecuritySettings'
import EditProfile from 'pages/Profile'
import ManageSubscription from 'pages/Organization/ManageSubscription'
import Forms from 'pages/Reporting/Forms'
import RunReports from 'pages/Reporting/RunReports'
import SmartImport from 'pages/SmartImport'
import Templates from 'pages/Templates'

import RequirePasswordChange from 'pages/auth/require-password-change'
import PasswordResetSuccess from 'pages/auth/password-reset-success'
import AuthLayout from 'layout/Auth'
import AccessError from 'pages/Organization/AccessError'

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'dashboard',
          element: <Dashboard />,
          protected: true,
        },
        {
          path: 'compplan',
          element: <CompensationPlan />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'employee/:userId/compplan/edit',
          element: <CreatePlanForEmployee />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'employee/:userId/compplan/all',
          element: <CompPlans />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'employee/:userId/compplan',
          element: <EmployeePlanView />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'organization',
          element: <Organization />,
          protected: true,
        },
        {
          path: 'company-settings',
          element: <OrganizationSettings />,
          protected: true,
        },
        {
          path: 'contact-settings',
          element: <OrganizationContactSettings />,
          protected: true,
        },
        {
          path: 'integration-settings',
          element: <SecuritySettings />,
          protected: true,
        },
        {
          path: 'period-settings',
          element: <ClosePeriods />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/plans',
          element: <PeriodPlansManagement />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/period-plans',
          element: <PeriodPlansManagement />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'wizard',
          element: <JumpStartWizard />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/organizations/manage',
          element: <ManageOrganizationStructure />,
          protected: true,
        },
        {
          path: 'admin/templates',
          element: <ManageTemplates />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/templates/create',
          element: <CreateTemplateSwitch />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/templates/:templateId/edit',
          element: <EditTemplateSwitch />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/templates/:templateId/view',
          element: <ViewTemplate />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/templates/:templateId/copy',
          element: <CopyTemplateSwitch />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/templates/select/:userId',
          element: <SelectTemplate />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/ledger-accounts',
          element: <ManageLedgerAccounts />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/accruals',
          element: <ManageAccruals />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/accrual-ledger',
          element: <Ledger />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/close-periods',
          element: <ClosePeriods />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/close-periods/:uuid',
          element: <ClosePeriod />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/components/targets/create',
          element: <CreateTargets />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/components/actuals/create',
          element: <CreateMetrics />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/approvals',
          element: <ManageApprovals />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/approvals/:approvalBatchId/edit',
          element: <EditApproval />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'profile',
          element: <EditProfile />,
          protected: true,
        },
        {
          path: 'manage-subscription',
          element: <ManageSubscription />,
          protected: true,
        },
        {
          path: 'templates',
          element: <Templates />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'create-comp-plan',
          element: <CreatePlanForEmployee />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'forms',
          element: <Forms />,
          protected: true,
        },
        {
          path: 'smart-import',
          element: <SmartImport />,
          protected: true,
          subscriptionTierFeature: ['REWARDS.ALL'],
        },
        {
          path: 'reports/run',
          element: <RunReports />,
          protected: true,
        },
        {
          path: 'admin/components/manage',
          element: <ManageComponents />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/components/:componentId/edit',
          element: <EditComponent />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/components/create',
          element: <CreateComponent />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/components/targets',
          element: <ManageTargets />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/components/actuals',
          element: <ManageMetrics />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/targets/edit',
          element: <EditTarget />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'admin/metrics/edit',
          element: <EditMetric />,
          protected: true,
          subscriptionTierFeature: ['INCENTIVE.ALL'],
        },
        {
          path: 'rewards/manage',
          element: <ManageRewards />,
          protected: true,
          subscriptionTierFeature: ['REWARDS.ALL'],
        },
        {
          path: 'rewards/create',
          element: <CreateRewards />,
          protected: true,
          subscriptionTierFeature: ['REWARDS.ALL'],
        },
        {
          path: 'rewards/edit',
          element: <EditRewards />,
          protected: true,
          subscriptionTierFeature: ['REWARDS.ALL'],
        },
        {
          path: 'rewards/packages',
          element: <RewardPackages />,
          protected: true,
          subscriptionTierFeature: ['REWARDS.ALL'],
        },
        {
          path: 'rewards/packages/create',
          element: <CreatePackage />,
          protected: true,
          subscriptionTierFeature: ['REWARDS.ALL'],
        },
        {
          path: 'rewards/packages/edit',
          element: <EditPackage />,
          protected: true,
          subscriptionTierFeature: ['REWARDS.ALL'],
        },
        {
          path: 'rewards/assign',
          element: <EmployeeRewards />,
          protected: true,
          subscriptionTierFeature: ['REWARDS.ALL'],
        },
        {
          path: 'rewards/:userId',
          element: <EmployeeRewardsDashboard />,
          protected: true,
          subscriptionTierFeature: ['REWARDS.ALL'],
        },
        {
          path: 'rewards/edit/:userId/:periodId',
          element: <EditEmployeeRewards />,
          protected: true,
          subscriptionTierFeature: ['REWARDS.ALL'],
        },
        {
          path: 'rewards/categories',
          element: <EditCategories />,
          protected: true,
          subscriptionTierFeature: ['REWARDS.ALL'],
        },
      ],
    },
    {
      path: '/',
      element: <Pages />,
      children: [
        {
          path: 'setup-in-progress',
          element: <PendingSetup />,
          protected: true,
        },
        {
          path: 'access-error',
          element: <AccessError />,
          protected: true,
        },
      ],
    },
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        {
          path: 'require-password-change',
          element: <RequirePasswordChange />,
          protected: true,
        },
        {
          path: 'password-reset-success',
          element: <PasswordResetSuccess />,
          protected: true,
        },
      ],
    },
  ],
}

export default MainRoutes
